import { put } from 'redux-saga/effects';
import { ContentLibraryTemplateParams } from 'features/content-library/types';
import { templateParamsChanged } from 'features/content-library/contentLibrarySlice';

export function* onSetTemplateParamsSaga(data: ContentLibraryTemplateParams) {
  yield put(templateParamsChanged(data));
}
